/**
 * Shared serializer helpers.
 *
 * Parsing strategy: we use DOMParser to walk the rendered tree rather
 * than regex-mangling raw HTML. Browser parser handles malformed input,
 * entity decoding, and whitespace normalisation for us.
 *
 * The PHP twin (adapters/.../serialize_for_platform) must produce the
 * same output for the same input — see docs/Reach/PHASE_1C.md §"Per-
 * platform serializer architecture". A 50-sample sync test lands in
 * 1c.2 polish.
 */

/**
 * Parse a canonical-HTML string into a DOM tree we can walk. Wraps in a
 * single element so callers can iterate childNodes uniformly. Empty /
 * whitespace-only input yields an empty wrapper.
 */
export function parseHtml(html) {
    const wrap = document.createElement('div');
    wrap.innerHTML = String(html || '');
    return wrap;
}

/**
 * Detect plain text vs HTML — mirrors the editor's looksLikeHtml().
 */
export function looksLikeHtml(s) {
    return /<\s*[a-zA-Z\/]/.test(String(s || ''));
}

/**
 * Normalise consecutive blank lines down to at most two. LinkedIn,
 * Instagram, X all render multi-blank as visible blank gaps; we cap
 * to avoid creators accidentally double-spacing the whole post.
 */
export function collapseBlankLines(s) {
    return String(s || '').replace(/\n{3,}/g, '\n\n');
}

/**
 * Strip leading / trailing whitespace per line + trim the whole string.
 */
export function tidy(s) {
    return collapseBlankLines(String(s || '').replace(/[ \t]+\n/g, '\n')).trim();
}
